import { useState, useEffect } from 'react';
import { formatCurrency } from '../utils/api';

export default function NumericKeypad({ value, onChange, onConfirm, currency = 'COP', label = 'Monto' }) {
  const [display, setDisplay] = useState(value ? String(value) : '');

  useEffect(() => {
    setDisplay(value ? String(value) : '');
  }, [value]);

  const handleKey = (key) => {
    if (key === '⌫') {
      const next = display.slice(0, -1);
      setDisplay(next);
      onChange(next);
      return;
    }
    if (key === '.' && display.includes('.')) return;
    if (display === '0' && key !== '.') {
      setDisplay(key);
      onChange(key);
      return;
    }
    if (display.length >= 12) return;
    const next = display + key;
    setDisplay(next);
    onChange(next);
  };

  const formatted = display
    ? formatCurrency(parseFloat(display) || 0, currency)
    : formatCurrency(0, currency);

  const keys = ['7','8','9','4','5','6','1','2','3','⌫','0','.'];

  return (
    <div style={styles.overlay} onClick={(e) => e.target === e.currentTarget && onConfirm()}>
      <div style={styles.sheet}>
        {/* Display */}
        <div style={styles.display}>
          <p style={styles.displayLabel}>{label}</p>
          <p style={styles.displayAmount}>
            {display ? formatted : <span style={{ color: 'var(--text-muted)' }}>$ 0</span>}
          </p>
        </div>

        {/* Keys */}
        <div style={styles.grid}>
          {keys.map(k => (
            <button
              key={k}
              type="button"
              onClick={() => handleKey(k)}
              style={{
                ...styles.key,
                ...(k === '⌫' ? styles.keyDelete : {}),
              }}
            >
              {k === '⌫' ? (
                <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M21 4H8l-7 8 7 8h13a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2z"/>
                  <line x1="18" y1="9" x2="12" y2="15"/><line x1="12" y1="9" x2="18" y2="15"/>
                </svg>
              ) : k}
            </button>
          ))}
        </div>

        {/* Confirm button */}
        <div style={{ display:'flex', gap:10 }}>
            <button
                type="button"
                onClick={() => { setDisplay(value ? String(value) : ''); onConfirm(); }}
                style={styles.cancelBtn}
            >
                Cancelar
            </button>
            <button
                type="button"
                onClick={onConfirm}
                style={{ ...styles.confirmBtn, flex: 2 }}
                disabled={!display || parseFloat(display) <= 0}
            >
                Confirmar
            </button>
            </div>
      </div>
    </div>
  );
}

const styles = {
  overlay: {
    position: 'fixed', inset: 0,
    background: 'rgba(0,0,0,0.6)',
    backdropFilter: 'blur(4px)',
    zIndex: 2000,
    display: 'flex', alignItems: 'flex-end',
  },
  sheet: {
    width: '100%',
    background: 'var(--bg-secondary)',
    borderRadius: '28px 28px 0 0',
    border: '1px solid var(--border)',
    padding: '24px 16px',
    paddingBottom: 'max(env(safe-area-inset-bottom), 24px)',
    animation: 'slideUp 0.3s cubic-bezier(0.34, 1.56, 0.64, 1)',
  },
  display: {
    textAlign: 'center',
    marginBottom: 24,
    padding: '16px',
    background: 'var(--bg-card)',
    borderRadius: 16,
    border: '1px solid var(--border)',
  },
  displayLabel: {
    fontSize: '0.8rem',
    color: 'var(--text-secondary)',
    marginBottom: 8,
    fontWeight: 500,
  },
  displayAmount: {
    fontSize: '2.4rem',
    fontWeight: 800,
    fontFamily: 'var(--font-display)',
    color: 'var(--text-primary)',
    letterSpacing: '-0.02em',
  },
  grid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(3, 1fr)',
    gap: 10,
    marginBottom: 12,
  },
  key: {
    height: 64,
    background: 'var(--bg-card)',
    border: '1px solid var(--border)',
    borderRadius: 14,
    color: 'var(--text-primary)',
    fontSize: '1.5rem',
    fontWeight: 600,
    fontFamily: 'var(--font-display)',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    transition: 'all 0.1s',
    WebkitTapHighlightColor: 'transparent',
    userSelect: 'none',
  },
  keyDelete: {
    background: 'var(--red-dim)',
    color: 'var(--red)',
    borderColor: 'rgba(255,84,112,0.2)',
  },
  confirmBtn: {
    width: '100%',
    padding: '18px',
    background: 'var(--accent)',
    border: 'none',
    borderRadius: 16,
    color: '#fff',
    fontSize: '1rem',
    fontWeight: 700,
    fontFamily: 'var(--font-body)',
    cursor: 'pointer',
    boxShadow: '0 0 24px rgba(124,111,255,0.4)',
    marginTop: 4,
  },
  cancelBtn: {
  flex: 1,
  padding: '18px',
  background: 'var(--bg-card)',
  border: '1px solid var(--border)',
  borderRadius: 16,
  color: 'var(--text-secondary)',
  fontSize: '1rem',
  fontWeight: 600,
  fontFamily: 'var(--font-body)',
  cursor: 'pointer',
},
};